import { render, staticRenderFns } from "./DeslizaAbajoComp.vue?vue&type=template&id=2530613d&scoped=true&"
var script = {}
import style0 from "./DeslizaAbajoComp.vue?vue&type=style&index=0&id=2530613d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2530613d",
  null
  
)

export default component.exports